import * as React from 'react';
import {connect} from 'react-redux';
import * as ContractModule from 'Modules/ContractModule';
import {withTranslation} from 'react-i18next';
import {CustomProps, IParentDetailsProps, ParentDetails} from 'components/Layout/DetailsSidebar/ParentDetails';
import {RootState} from 'Redux/Reducers/_RootReducer';
import {ContractSelectors} from "Redux/Selectors/ContractSelectors";
import {NavLink} from "react-router-dom";
import * as Dictionary from "Models/Dictionary";
import {EnumTypes as PageEnumTypes} from "Models/EnumTypes/PageEnumTypes";
import * as ViewManagementModule from "Modules/ViewManagementModule";

interface IP extends IParentDetailsProps {
    history: any;
}

type ConnectedP = {
    activeEl: ContractModule.Types.ContractSingleDto;
};
type DispatchedP = {
    setActivePage: Function;
    setCurrentContractVin: Function;
};

type S = {};

class ContractListDetails extends ParentDetails<IP & ConnectedP & DispatchedP, S> {

    public getCustomProps(): CustomProps {
        const {activeEl} = this.props;
        return {
            ...(this.props as any),
            activeEl,
            extrnalRender: () => this.externalRender()
        };
    }

    protected setTurnOffDate = () => {
        if (!this.buttonIsDisabled()) {
            const {activeEl} = this.getCustomProps();
            this.props.history.push(`${Dictionary.PageUrl.get(PageEnumTypes.Page.CONTRACT_MANAGEMENT)}/${activeEl.id}/change-off-date`);
        }
    };

    private externalRender() {
        const {activeEl, setActivePage, setCurrentContractVin} = this.getCustomProps();
        const isBtnDisabled = this.buttonIsDisabled();
        const classNameBtnState = isBtnDisabled ? ' details-right__dashboard-item--disabled ' : '';

        return (
            <>
                <LinkHoc isActive={!isBtnDisabled}
                         pageType={PageEnumTypes.Page.TERMINAL_INSTALLATION}
                         setActivePage={setActivePage}
                         onClickAction={setCurrentContractVin.bind(this, activeEl?.vin)}>
                    <div className={'details-right__dashboard-icon'}>
                        <img src={`/images/icons/terminal-installation.svg`} alt=""
                             className="details-right__dashboard-icon--mini"/>
                    </div>
                    <span>Przejdź do zlecenia</span>
                </LinkHoc>

                <LinkHoc isActive={!isBtnDisabled}
                         pageType={PageEnumTypes.Page.CARS_MANAGEMENT}
                         setActivePage={setActivePage}
                         onClickAction={setCurrentContractVin.bind(this, activeEl?.vin)}>
                    <div className={'details-right__dashboard-icon'}>
                        <img src={`/images/icons/fleet.svg`} alt="" className="details-right__dashboard-icon--mini"/>
                    </div>
                    <span>Przejdź do samochodu</span>
                </LinkHoc>

                <div className={`details-right__dashboard-item ${classNameBtnState}`}
                     data-testid="menu-turn-off-date"
                     onClick={this.setTurnOffDate}>
                    <div className={'details-right__dashboard-icon'}>
                        <img src={`/images/icons/calendar_blue.svg`} alt=""
                             className="details-right__dashboard-icon--mini"/>
                    </div>
                    <span> Zmień datę wyłączenia </span>
                </div>
            </>
        );
    }
}

interface ILinkHoc {
    isActive: boolean;
    pageType: PageEnumTypes.Page;
    setActivePage: Function;
    onClickAction?: Function;
    children: any;
    testId?: string;
}

export const LinkHoc = ({isActive, pageType, setActivePage, onClickAction, children, testId}: ILinkHoc) => {
    if (isActive) {
        return <NavLink exact to={Dictionary.PageDetails.get(pageType).url}
                        className="details-right__dashboard-item"
                        data-testid={testId}
                        onClick={() => {
                            setActivePage(Dictionary.PageDetails.get(pageType));
                            if (onClickAction) {
                                onClickAction();
                            }
                        }}>
            {children}
        </NavLink>
    } else {
        return <div className="details-right__dashboard-item details-right__dashboard-item--disabled"
                    data-testid={testId}>
            {children}
        </div>
    }
};


function mapStateToProps(state: RootState): ConnectedP {
    return {
        activeEl: ContractSelectors.getActiveContract(state)
    };
}

function mapDispatchToProps(dispatch: any): DispatchedP {
    return {
        setActivePage: (page: ViewManagementModule.Types.Page) => dispatch(ViewManagementModule.Actions.setActivePage(page)),
        setCurrentContractVin: (currentVin) => dispatch(ContractModule.Actions.setCurrentContractVin(currentVin))
    };
}

export default withTranslation(['carDetails', 'tables', 'form'])(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(ContractListDetails) as React.ComponentType<any>
);



// WEBPACK FOOTER //
// ./src/components/Layout/DetailsSidebar/ContractListDetails.tsx